import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";
import { DateFormat, DateTimeFormat } from '@vex/constants/settings';

@Pipe({
  name: "dateFormat"
})
export class DateFormatPipe implements PipeTransform {

  constructor(public datepipe: DatePipe) {}

  transform(value: any, format = 'DT'): string {

    if (!value || value === "null") return '';

    let date: Date;

    if (typeof value === 'string') {
      const hasTimezone = /Z$|[+-]\d{2}:\d{2}$/.test(value);

      date = hasTimezone ? new Date(value) : new Date(value + 'Z');
    } else {
      date = new Date(value);
    }

    if (format === 'D') {
      return this.datepipe.transform(date, DateFormat) || '';
    } else {
      return this.datepipe.transform(date, DateTimeFormat) || '';
    }
  }
}